/**
 * Define our route selectable stylesheets
 *
 * @type {Object}
 */
const stylesheets = {
    minimal:
    "https://unpkg.com/@ditdot-dev/vue-flow-form@2.1.0/dist/vue-flow-form.theme-minimal.min.css",
    green:
    "https://unpkg.com/@ditdot-dev/vue-flow-form@2.1.0/dist/vue-flow-form.theme-green.min.css",
    purple:
    "https://unpkg.com/@ditdot-dev/vue-flow-form@2.1.0/dist/vue-flow-form.theme-purple.min.css",
    pink:
    "https://cdn.tiagoaguiar.co/static/css/theme-pink.css",
    black:
    "/css/theme-black.css"
};

const cssElement = document.getElementById("stylesheet");

/**
 * Set the default fallback stylesheet
 * @type {[type]}
 */
const defaultStylesheet = stylesheets.minimal;

export default function stylesheet(to, from, next) {
  if (to.meta.stylesheet !== from.meta.stylesheet) {
    cssElement.href = stylesheets[to.meta.stylesheet] || defaultStylesheet;
  }

  return next();
}
